/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdWebFeaturesGamesChooseGamePortalConfigFromJSON, FxIdWebFeaturesGamesChooseGamePortalConfigToJSON, } from './FxIdWebFeaturesGamesChooseGamePortalConfig';
import { FxIdWebFeaturesGamesChooseGameResponsePublicGameDataFromJSON, FxIdWebFeaturesGamesChooseGameResponsePublicGameDataToJSON, } from './FxIdWebFeaturesGamesChooseGameResponsePublicGameData';
/**
 * Check if a given object implements the FxIdWebFeaturesGamesChooseGameResponse interface.
 */
export function instanceOfFxIdWebFeaturesGamesChooseGameResponse(value) {
    if (!('PortalConfig' in value) || value['PortalConfig'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesGamesChooseGameResponseFromJSON(json) {
    return FxIdWebFeaturesGamesChooseGameResponseFromJSONTyped(json, false);
}
export function FxIdWebFeaturesGamesChooseGameResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'PortalConfig': FxIdWebFeaturesGamesChooseGamePortalConfigFromJSON(json['PortalConfig']),
        'PublicGameData': json['PublicGameData'] == null ? undefined : FxIdWebFeaturesGamesChooseGameResponsePublicGameDataFromJSON(json['PublicGameData']),
    };
}
export function FxIdWebFeaturesGamesChooseGameResponseToJSON(json) {
    return FxIdWebFeaturesGamesChooseGameResponseToJSONTyped(json, false);
}
export function FxIdWebFeaturesGamesChooseGameResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'PortalConfig': FxIdWebFeaturesGamesChooseGamePortalConfigToJSON(value['PortalConfig']),
        'PublicGameData': FxIdWebFeaturesGamesChooseGameResponsePublicGameDataToJSON(value['PublicGameData']),
    };
}
//# sourceMappingURL=FxIdWebFeaturesGamesChooseGameResponse.js.map